import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
`

export const ContainerCard = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 15px;
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 86px;
  padding-top: 30px;
  padding-left: 41px;
  padding-right: 41px;
  @media (max-width: 806px) {
    display: none;
  }
`

export const TitleTextMobile = styled.h1`
  font-size: 16px;
  font-weight: 600;
`

export const TitleChart = styled.h2`
  font-size: 28px;
  font-weight: 500;
`

export const TitleContainerMobile = styled.div`
  display: none;
  @media (max-width: 806px) {
    display: flex;
    margin-bottom: 1rem;
  }
`

export const TitleChartContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 300px;
`

export const SelectContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`

export const SelectIndividualContainer = styled.div`
  padding: 16px;
  border: 1px solid #b7b7b7;
  border-radius: 5px;
  width: 12.6875rem;
  height: 50px;
`

export const TicketTypeSelect = styled.select`
  display: flex;
  width: 100%;
  border: none;
  background: #fff;
  padding: 0px;
  outline: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
`

export const LineContainer = styled.div`
  padding: 45px 45px 70px 45px;
  height: 500px;
  @media (max-width: 806px) {
    padding: 15px;
    height: 200px;
  }
`
